import useTranslation from "next-translate/useTranslation";
import Popup from "@/components/ui/popup";
import { subscribe, useWebPush } from "@/redux/webPush";
import { Button } from "@/components/ui/button";

export default function WebPushPopup({ show }) {
  const { t } = useTranslation("common");

  const { canSubscribe } = useWebPush();

  if (!canSubscribe) {
    return null;
  }

  return (
    <Popup title={t("Get notified")} onClose={() => show(false)}>
      <div>{t("Get notified desc")}</div>

      <div className="flex justify-end items-center pt-4 mt-4 w-full">
        <Button variant="outline" size="wide" onClick={() => show(false)}>
          {t("Cancel")}
        </Button>
        <button
          className="ml-3 btn btn-base btn-blue"
          onClick={() => {
            if (process.env.NODE_ENV === "production") {
              subscribe();
            }
            show(false);
          }}
        >
          {t("Accept")}
        </button>
      </div>
    </Popup>
  );
}
